import React__default from 'react';
import classNames from 'classnames';
import { Text, Icon, UnstyledLink } from '@shopify/polaris';
import styles from './ExitAction.scss.mjs';
import { useMediaQuery } from '../../../MediaQueryProvider/MediaQueryProvider.mjs';
import Exit from './icons/Exit.svg.mjs';
import { Title } from './components/Title/Title.mjs';

function ExitAction({
  label,
  accessibilityLabel,
  animated = false,
  children,
  url,
  onAction
}) {
  const {
    mobile
  } = useMediaQuery();
  const exitActionWrapperClassNames = classNames(styles.ExitActionWrapper, {
    [styles.animated]: !mobile && animated
  });
  const labelMarkup = mobile ? null : /*#__PURE__*/React__default.createElement("div", {
    className: styles.Label
  }, /*#__PURE__*/React__default.createElement(Text, {
    variant: "bodyMd",
    as: "span"
  }, label));
  const contentMarkup = /*#__PURE__*/React__default.createElement("div", {
    className: styles.Content
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.IconWrapper
  }, /*#__PURE__*/React__default.createElement(Icon, {
    source: Exit,
    accessibilityLabel: mobile ? label : undefined
  })), labelMarkup);
  const commonProps = {
    className: styles.ExitAction,
    'aria-label': accessibilityLabel
  };
  const actionMarkup = url ? /*#__PURE__*/React__default.createElement(UnstyledLink, Object.assign({}, commonProps, {
    url: url
  }), contentMarkup) : /*#__PURE__*/React__default.createElement("button", Object.assign({}, commonProps, {
    type: "button",
    onClick: onAction
  }), contentMarkup);
  const childrenMarkup = children ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.ChildrenWrapper
  }, children) : null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: exitActionWrapperClassNames
  }, actionMarkup, childrenMarkup);
}
ExitAction.Title = Title;

export { ExitAction };
